// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageLoadAnimation_wrapper__3xAcH","pageLoad":"PageLoadAnimation_pageLoad__3wwZ4","inner":"PageLoadAnimation_inner__1QFe0"};